import React, { Component } from 'react';
import { Form, Modal, Button, message } from 'antd';
import { Message } from 'semantic-ui-react';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';

class DelCptModalDialog extends Component {
  componentDidUpdate() {
    const { delCptActionStatus } = this.props;
    if (delCptActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Delete CPT succeeded');
      this.props.initDelCptActionStatus();
      this.props.resetDelCptModal();
      this.refreshQuery();
    }
    if (delCptActionStatus === ACTION_STATUS.ERROR) {
      this.props.initDelCptActionStatus();
    }
  }

  refreshQuery = () => {
    const { employee, year } = this.props.cptQueryFields;
    this.props.loadCptInfo({ employee, year });
  };

  submitDelCpt = () => {
    Modal.confirm({
      title: 'Are you sure to delete this record?',
      onOk: () => {
        const { id } = this.props.delCptModal.fields;
        this.props.delCpt({ id });
      },
    });
  };

  render() {
    const { delCptModal, delCptActionStatus } = this.props;
    const { isOpened, respErrMsg } = delCptModal;
    const isSubmitLoading = delCptActionStatus === ACTION_STATUS.LOGINING;

    return (
      <Modal
        title="Del CPT"
        centered
        width={420}
        visible={isOpened}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={this.props.resetDelCptModal}
        footer={[
          <Button key="close" onClick={this.props.resetDelCptModal}>
            Close
          </Button>,
          <Button key="submit" type="primary" loading={isSubmitLoading} onClick={this.submitDelCpt}>
            Submit
          </Button>,
        ]}
      >
        {!!respErrMsg && (
          <Message negative>
            <Message.Header>Response Error Message</Message.Header>
            <p>{respErrMsg}</p>
          </Message>
        )}
      </Modal>
    );
  }
}

const DelCptModalDialogForm = Form.create({ name: 'DelCptModalDialog' })(DelCptModalDialog);

export default DelCptModalDialogForm;
